if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      // The responsive footer layout is not interactive, so its details must
      // stay open at every breakpoint.
      this.open = true;

      document.addEventListener('matchMobile', () => {
        this.open = true;
      });

      document.addEventListener('matchTablet', () => {
        this.open = true;
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });

      document.addEventListener('unmatchMobile', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
